import { ConfigurationError } from '../../utility';


export const createNeedCredential = ({
  fetchListMethodKey = 'fetchList'
} = {}) => {

  return {
    data: function () {
      return {
        username: '',
        password: '',

        authenticated: false,

        invalidLogin: false,

        authenticating: false,
      };
    },
    computed: {
      credentialExists: function () {
        return (
          this.username &&
          this.username.length > 3 &&
          this.password &&
          this.password.length > 3 &&
          this.authenticated
        );
      },
      loginFormData() {
        return {
          invalidLogin: this.invalidLogin,
          authenticated: this.authenticated,
          authenticating: this.authenticating,
        }
      }
    },
    methods: {
      onLoginUserChange: async function (user) {
        this.invalidLogin = false;
        this.authenticating = true;
        this.username = user.username;
        this.password = user.password;
        if (!this[fetchListMethodKey]) {
          throw ConfigurationError('Provide a valid Fetch List Method');
        }
        try {
          await this[fetchListMethodKey]();
          this.authenticated = true;
          this.resetLogin();
        } catch (error) {
          console.log("error", error);
          if (error == "invalid login.") {
            console.error('INVALD');
            this.invalidLogin = true;
          }
        } finally{
          this.authenticating = false;
        }
      },
      resetLogin() {
        // Because the Global List Refresh, we need the username and password 
        // to retain their old values from the Login Form
        
        // this.username = '';
        // this.password = '';
        this.invalidLogin = false;
        this.authenticating = false;
      },
    }
  }
};